<template>
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.46162 8.9376C3.38773 8.9376 2.51367 8.06354 2.51367
    6.98966V2.2918H1.71162C1.01631 2.2918 0.451172 2.85685 0.451172 3.55216V9.73965C0.451172
    10.435 1.01631 11.0001 1.71162 11.0001H7.44073C8.13603 11.0001 8.70117
    10.435 8.70117 9.73965V8.9376H4.46162Z" fill="#0D7BC4"/>
    <path d="M10.5345 1.26044C10.5345 0.564217 9.97026 0 9.27412 0H4.46162C3.76539 0 3.20117
    0.564217 3.20117 1.26044V6.98956C3.20117 7.68578 3.76539 8.25 4.46162 8.25H9.27412C9.97026
    8.25 10.5345 7.68578 10.5345 6.98956V1.26044Z" fill="#0D7BC4"/>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconCopy'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconCopy.vue